/* eslint-disable */
import * as Types from '../../../types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from 'graphql-tag';
export type CheckAccountLockingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CheckAccountLockingQuery = { __typename: 'Query', account?: { __typename: 'Account', isAccountLocked?: boolean | null } | null };


export const CheckAccountLockingDocument = gql`
    query CheckAccountLocking {
  account {
    isAccountLocked
  }
}
    ` as unknown as DocumentNode<CheckAccountLockingQuery, CheckAccountLockingQueryVariables>;